/**
 * Shared frosted-glass surface for EVERY floating whiteboard toolbar (tool palette, top bar, object +
 * connector inspectors). Kept in one place so they never drift apart. A high-opacity surface keeps the
 * panel its own colour (so its icons stay legible) rather than taking on whatever it floats over, and a
 * strong backdrop blur mutes busy/bright content behind it — the two together are what guarantee contrast
 * over any board content. Compose with `cn(GLASS, '<rounding + layout classes>')`.
 */
export const GLASS = 'border border-line bg-surface-raised/95 shadow-lg backdrop-blur-xl';
